<template>
  <UiInputNumberFieldVeeBase v-bind="{ ...$props, ...$attrs }" />
</template>

<script lang="ts">
import type { PropType } from 'vue'

export default {
  name: 'UiInputNumberFieldVee',
  inheritAttrs: false,
  props: {
    name: { type: String, required: true as const },
    label: { type: String, default: undefined },
    // type: null skips Vue's runtime type check — Number would fail it for a null
    // value (typeof null !== 'number'), which is the normal state before a value
    // is entered. The PropType cast keeps this typed as number | null for
    // TypeScript regardless.
    modelValue: { type: null as unknown as PropType<number | null>, required: true as const },
    min: { type: Number, default: undefined },
    max: { type: Number, default: undefined },
    decimals: { type: Number, default: undefined },
    showAsRequired: { type: Boolean, default: undefined },
    isRequired: { type: Boolean, default: undefined },
    isDisabled: { type: Boolean, default: undefined },
    validateOnInput: { type: Boolean, default: undefined },
    unit: { type: String, default: undefined },
  },
}
</script>

